'use strict';
angular.module('mso.services')
    .factory('RuleService', ['enums', function (enums) {
        const rulesService = {
            r5388IsBTL: function (propertyPurpose) {
                return Number.parseInt(propertyPurpose) === enums.RDPropertyPurposeTypeCode.buyToLet;
            },

            r5417BankServiceIntegrationAvailable: function (p6079) {
                return p6079 === 'True';
            },

            r5838IntermediaryUserOlderMinAge: function (birthDate, p6148MinimumIntermediaryUserAgeInYearsAtRegistration) {
                if (birthDate !== undefined && birthDate !== null) {
                    const difference = moment(birthDate).add(Number.parseInt(p6148MinimumIntermediaryUserAgeInYearsAtRegistration), 'years').diff(moment());
                    return difference < 0;
                }
                
                return false;
            },

            r5847IntermediaryUserYoungerMaxAge: function (birthDate, p6151MaximumIntermediaryUserAgeInYearsAtRegistration) {
                if (birthDate !== undefined && birthDate !== null) {
                    var difference = moment(birthDate).add(Number.parseInt(p6151MaximumIntermediaryUserAgeInYearsAtRegistration), 'years').diff(moment());
                    return difference > 0;
                }
                
                return false;
            },

            r5920ConsumerBTLIsNonRegulated: function (applicationType, intendedFamilyOccupancy, previousFamilyOccupancy, familyOccupancy, ownOtherLetProperties) {
                return familyOccupancy === false || previousFamilyOccupancy === false || ownOtherLetProperties === true ||
                    (intendedFamilyOccupancy === false && this.r7004IsNewPurchase(applicationType))
            },

            r7004IsNewPurchase: function (applicationType) {
                return Number.parseInt(applicationType) === enums.RDApplicationTypeCode.newPurchase;
            }
        };

        return rulesService;
    }
]);
